import React, { useState } from "react";
import { Card, Button, Form, Row, Col, Badge, Spinner } from "react-bootstrap";
import connectionService from "../../../services/connectionService";

const TestTab = ({ connectionId, form, channel }) => {

    const [loading, setLoading]       = useState(false);
    const [log, setLog]               = useState(null);
    const [status, setStatus]         = useState("offline");
    const [testPhone, setTestPhone]   = useState("");

    // -------------------------------------------------------
    // TESTAR CONEXÃO
    // -------------------------------------------------------
    const testConnection = async () => {
        setLoading(true);
        setStatus("loading");
        setLog(null);

        try {
            const response = await connectionService.test(connectionId);
            setStatus(response.success ? "online" : "error");
            setLog(response);
        } catch (err) {
            setStatus("error");
            setLog({
                success: false,
                message: err.response?.data?.message || "Erro ao testar conexão."
            });
        } finally {
            setLoading(false);
        }
    };

    // -------------------------------------------------------
    // ENVIAR MENSAGEM DE TESTE
    // -------------------------------------------------------
    const sendTestMessage = async () => {
        if (!testPhone) return;

        setLoading(true);
        setLog(null);

        try {
            const response = await connectionService.sendMessage(
                connectionId,
                testPhone,
                "Mensagem de teste enviada pelo sistema"
            );
            setStatus(response.success ? "online" : "error");
            setLog(response);
        } catch (err) {
            setStatus("error");
            setLog({
                success: false,
                message: err.response?.data?.message || "Erro ao enviar mensagem."
            });
        } finally {
            setLoading(false);
        }
    };

    // -------------------------------------------------------
    // BADGE DE STATUS
    // -------------------------------------------------------
    const getStatusBadge = () => {
        switch (status) {
            case "online":  return <Badge bg="success">Online</Badge>;
            case "offline": return <Badge bg="secondary">Offline</Badge>;
            case "error":   return <Badge bg="danger">Erro</Badge>;
            case "loading": return <Badge bg="warning">Testando...</Badge>;
            default:        return null;
        }
    };

    return (
        <>
            {/* HEADER */}
            <Card className="mb-3 border-0 bg-light">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <strong>Teste de conexão</strong>
                            <div className="text-muted small">
                                Valide se sua integração está funcionando corretamente
                            </div>
                        </div>
                        <div>{getStatusBadge()}</div>
                    </div>
                </Card.Body>
            </Card>

            {/* ACTIONS */}
            <Card className="mb-3">
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <Button
                                variant="primary"
                                onClick={testConnection}
                                disabled={loading}
                                className="w-100"
                            >
                                {loading ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Testando conexão...
                                    </>
                                ) : (
                                    "Testar conexão"
                                )}
                            </Button>
                        </Col>
                        <Col md={6}>
                            <Button
                                variant="outline-primary"
                                onClick={() => {
                                    setStatus("offline");
                                    setLog(null);
                                }}
                                className="w-100"
                                disabled={loading}
                            >
                                Resetar status
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* ENVIO DE MENSAGEM */}
            <Card className="mb-3">
                <Card.Body>
                    <strong>Teste de envio de mensagem</strong>
                    <div className="text-muted small mb-3">
                        Envie uma mensagem real para validar o fluxo da API
                    </div>
                    <Row>
                        <Col md={8}>
                            <Form.Control
                                placeholder={channel === "instagram"
                                    ? "Instagram-scoped ID do destinatário"
                                    : "Número com DDI (ex: 5561999999999)"}
                                value={testPhone}
                                onChange={(e) => setTestPhone(e.target.value)}
                            />
                        </Col>
                        <Col md={4}>
                            <Button
                                variant="success"
                                onClick={sendTestMessage}
                                disabled={loading || !testPhone}
                                className="w-100"
                            >
                                Enviar teste
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* LOG */}
            <Card>
                <Card.Body>
                    <div className="d-flex justify-content-between">
                        <strong>Log da API</strong>
                        <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => setLog(null)}
                        >
                            Limpar
                        </Button>
                    </div>
                    <div
                        style={{
                            background: "#0d1117",
                            color: "#d1d5db",
                            padding: 15,
                            borderRadius: 8,
                            marginTop: 10,
                            minHeight: 120,
                            fontSize: 13,
                            fontFamily: "monospace"
                        }}
                    >
                        {log ? (
                            <pre style={{ margin: 0 }}>
                                {JSON.stringify(log, null, 2)}
                            </pre>
                        ) : (
                            "Nenhum log ainda..."
                        )}
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default TestTab;
